<template>
    <layout-machine-introduction :unsaved-puri-count="unsavedPuriCount"
                                 :latest-image-id="latestImageId"
                                 :is-searchable="isSearchable"
                                 :machine-id="machineId"
                                 :section-title-list="sectionTitleList"
                                 :has-border-anchor-link="false"
                                 :has-title-anchor-link="false"
                                 :has-top-border-anchor-link="false"
                                 :has-movie-title="false"
                                 :has-movie="false"
    >
        <template v-slot:content-campaign>
            <img :src="buildImgUrl('contents_campaign_bk.png')" alt="CENTI:U SPECIAL CONTENTS">
            <a @click="transitionPage('https://youtu.be/zYx-MhOTZ60', 'SPECIAL MOVIE', '_blank', 'youtube')">
                <p class="movie-thumb"><img :src="buildImgUrl('contents_campaign_movie.png')" alt="CENTI:U SPECIAL MOVIE"></p>
            </a>
        </template>
        <template v-slot:feature-summary>
            <img :src="buildImgUrl('feature_summary.png')" alt="CENTI:Uの基本情報">
        </template>
        <template v-slot:content-1>
            <p class="img-01"><img :src="buildImgUrl('contents_01.png')" alt="選べる2つのライトとミラー張りの小型空間で可愛く撮影できる♡"></p>
        </template>
        <template v-slot:content-2>
            <div class="cont-02">
                <p class="img-01"><img :src="buildImgUrl('contents_02.png')" alt="お気に入りがきっと見つかる3つのカメラ画角 自分たちに合わせて撮影の楽しみ方を変えられる撮影モード"></p>
            </div>
        </template>
        <template v-slot:content-3>
            <div class="cont-03">
                <p class="img-01"><img :src="buildImgUrl('contents_03.png')" alt="おしゃれなフィルターとフレームでもっと楽しめる♡"></p>
            </div>
        </template>
        <template v-slot:content-4>
            <p class="img-01"><img loading="lazy" :src="buildImgUrl('contents_04.gif')" alt="撮影の様子を記録した動画で楽しい瞬間をさらに残せる！"></p>
        </template>
        <template v-slot:content-5>
            <p class="img-01"><img loading="lazy" :src="buildImgUrl('contents_05.png')" alt="ワンタッチでかんたんに可愛くできる　全部で20種類！"></p>
        </template>
    </layout-machine-introduction>
</template>

<script>
import LayoutMachineIntroduction from "../../templates/LayoutMachineIntroduction.vue";
import * as urlUtil from "../../../util/UrlUtil";
import {mapActions} from "vuex";
import {getClickAllEvent} from "../../../util/Ga4EventUtil.js";

export default {
    name: "MachineCentiu1",
    components: { LayoutMachineIntroduction },
    data() {
        return {
            machineId: 168,
            sectionTitleList: [
                '01 誰とでも撮りたくなる「自然で可愛い写り」',
                '02 3つのアングルで自由度UP！「撮影体験」',
                '03 フルサイズ感が可愛い「シールデザイン」',
                '04 思い出残せる「音声付き動画」',
                '05 CENTI:Uの画像にぴったりな「落書き」',
            ],
        }
    },
    props: {
        /**
         * Headerコンポーネント用
         * 未保存プリ数
         */
        unsavedPuriCount: {
            type: String,
            required: true
        },
        /**
         * Headerコンポーネント用
         * 最新プリID
         */
        latestImageId: {
            type: String,
            required: true
        },
        /**
         * 当該機種が「遊べるお店を探す」によって検索可能であるかどうかを判定する.
         * toolboxから取得
         * 「遊べるお店を探す」表示判定
         */
        isSearchable: {
            type: Boolean,
            required: true
        },
    },
    mounted() {
        /**
         * TheHeader,TheFooterでstoreのaccountStatusを使用するため、予めstoreに保存しておく
         * FIXME:ここでの取得を忘れてもエラーが出ず気づかない可能性があるため、VOYAGERFRONT-5558で修正予定
         */
        this.getAccountStatus()
    },
    methods: {
        ...mapActions({
            getAccountStatus: 'AccountStoreV2/getAccountStatus'
        }),
        /**
         * 画像のURLを組み立てる
         * @param {string} imgName 画像名
         */
        buildImgUrl(imgName) {
            return urlUtil.imageUrlUtil.machineIntroductionImageUrl(String(this.machineId), imgName)
        },
        /**
         * cssのurl関数の呼び出し部分の含めた文字列を返す
         * styleタグ内でv-bindで使用することを想定している
         */
        buildStyleImgUrl(imageName) {
            const imgUrl = this.buildImgUrl(imageName)
            return `url(${imgUrl})`;
        },
        /**
         * GA4イベントを送信してから指定したページに遷移させる
         * @param {string} url elementUrl
         * @param {string} elementText elementText
         * @param {string} transitionTarget 別窓指定
         */
        transitionPage(url, elementText, transitionTarget) {
            getClickAllEvent(url, elementText)
            window.open(url, transitionTarget)
        },
    }
}
</script>

<style scoped lang="scss">
@use "../../../../scss/v2/base/variables";
@use "sass:math";

$deviceWidth: 750px;

:deep(*) {
    .c-machine-introduction {
        &-top {
            .content-campaign {
                position: relative;
                .movie-thumb {
                    position: absolute;
                    width: math.percentage(math.div(670px, $deviceWidth));
                    top: math.percentage(math.div(160px, $deviceWidth));
                    left: math.percentage(math.div(40px, $deviceWidth));
                }
            }

            .btn-shop-list {
                position: absolute;
                top: math.percentage(math.div(256px, $deviceWidth));
                width: 100%;
                &-link {
                    width: math.percentage(math.div(530px, $deviceWidth));
                }
            }
            .list-anchor-link {
                padding: (variables.$grid-base) 0 (variables.$grid-base * 1.5) 0;

                .img-link {
                    width: math.percentage(math.div(640px, $deviceWidth));
                }
            }

            .feature-summary {
                width: math.percentage(math.div(610px, $deviceWidth));
                padding: 0 0 (variables.$grid-base * 2) 0;
                margin: auto;
            }
        }
        &-contents {
            .accordion-inner {
                .img-01{
                    margin-top: -1px;
                }
            }
        }
    }
}

</style>
